import { render, staticRenderFns } from "./editNameAndSort.vue?vue&type=template&id=76a9ac46&scoped=true"
import script from "./editNameAndSort.vue?vue&type=script&lang=js"
export * from "./editNameAndSort.vue?vue&type=script&lang=js"
import style0 from "./editNameAndSort.vue?vue&type=style&index=0&id=76a9ac46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a9ac46",
  null
  
)

export default component.exports